import { env as SERVER_URL } from "./env";
import * as commonjs from "./common";

let numhyphenRule = /^(?!.*--)[0-9]+(-[0-9]+)*$/;
let idRule = /^[a-z0-9]{6,20}$/i;
let pwdRule = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*?_]).{8,16}$/i;
let emailRule = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
let phone2Rule = /^[0-9]{3,4}$/i;
let phone3Rule = /^[0-9]{4}$/i;
let busiRule = /^\d{3}-\d{2}-\d{5}$/;

function DOMLoaded() {
	console.info('RegisterJS-DOMLoaded()');

	// All event listeners and functions follow here
	document.addEventListener('keydown', function (e) {
		if (e.target && e.target.id === 'checknum') {
			if (e.defaultPrevented) {
				return;
			}
			var handled = false;
			if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
				handled = true;
			} else if (e.keyCode === 8) {
				handled = true;
			} else if (e.keyCode === 16) {
				handled = true;
			} else if ((e.keyCode === 17 && e.keyCode === 86) || e.keyCode === 17 && e.keyCode === 229) {
				handled = true;
			} else {
				handled = false;
			}
			if (!handled) {
				e.preventDefault();
			}
		}
	});

	document.addEventListener('keyup', function (e) {
		if (e.target && e.target.id === 'checknum') {
			if (e.target.value.length === 6) {
				document.getElementById("checknum_confirm").classList.add('on');
			} else {
				document.getElementById("checknum_confirm").classList.remove('on');
			}
		}
	});

	/*
	document.addEventListener('keyup', function (e) {
		if (e.target && (e.target.id === 'phone2' || e.target.id === 'phone3')) {
			// 240621 입력시 인증여부와 상관없이 자릿수 맞으면 전송버튼 뜸.
			if (document.getElementById("phone2").value.length < 3 || document.getElementById("phone3").value.length < 4) {
				document.getElementById("req_checknum_btn").classList.remove('on');
				document.getElementById('checknum_wrap').classList.remove('on');
			} else {
				document.getElementById("req_checknum_btn").classList.add('on');
			}
		}
	});
	*/

	document.addEventListener('keyup', function (e) {
		if (e.target && e.target.id === 'b_checkmail') {
			if (e.target.value.length === 6) {
				document.getElementById("b_checkmail_confirm").classList.add('on');
			} else {
				document.getElementById("b_checkmail_confirm").classList.remove('on');
			}
		}
	});

	document.addEventListener('input', function (e) {
		if (e.target && e.target.id === 'b_mail1') {
			if (emailRule.test(document.getElementById("b_mail1").value)) {
				document.getElementById("b_req_checkmail_btn").classList.add('on');
			} else {
				document.getElementById("b_req_checkmail_btn").classList.remove('on');
				document.getElementById('checkmail_wrap').classList.remove('on');
			}
		}
	});

	document.addEventListener('click', function (e) {
		if (e.target && e.target.id === 'b_req_checkmail_btn') {
			if (!emailRule.test(document.getElementById("b_mail1").value)) {
				commonjs.formSwal('이메일', '이메일', '#b_mail1', 'type');
				return false;
			} else {
				try {
					var url = "./headless.php?app=member&act=cert_email";
					var v = document.getElementById("b_mail1").value;
					var data = {
						"m_email": v
					};
					fetch(url, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(data)
					})
					.then(response => response.json())
					.then(result => {
						if (result.cert_code) {
							document.getElementById("b_req_checkmail_btn").classList.remove('on');
							document.getElementById('checkmail_wrap').classList.add('on');
							document.getElementById('b_checkmail').classList.add('on');
							console.log('[개발자모드] 인증코드:' + result.cert_code);
							setTimeout(function () {
								send_email_code(v, result.cert_code);
							}, 1000);
						} else {
							Swal.fire({
								title: '전송 실패',
								text: '오류가 발생해서 전송에 실패했습니다.' + result.common.errMsg,
								icon: 'error',
								confirmButtonText: '확인',
								// allowOutsideClick: false,  // 외부 클릭 방지
								// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
							});
						}
					});
				} catch (error) {
					Swal.fire({
						title: '요청 오류 ',
						text: '데이터 요청중 오류가 발생했습니다.',
						icon: 'error',
						confirmButtonText: '확인',
						// allowOutsideClick: false,  // 외부 클릭 방지
						// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
					});
					console.error(error?.response?.data);
				}
			}
		}
	});

	document.addEventListener('keydown', function (e) {
		if (e.target && (e.target.id === 'mb_tel' || e.target.id === 'mb_bank_acc')) {
			var allowedKeys = [
				48, 49, 50, 51, 52, 53, 54, 55, 56, 57, // 0-9 (top row)
				96, 97, 98, 99, 100, 101, 102, 103, 104, 105, // 0-9 (numpad)
				189, 109, // Hyphen
				8, 46, // Backspace, Delete
				9, // Tab
				37, 39 // ArrowLeft, ArrowRight
			];
			if (!allowedKeys.includes(e.keyCode)) {
				e.preventDefault();
				return false;
			}
	
			if (e.key === '-' || e.keyCode === 189 || e.keyCode === 109) {
				var cursorPos = e.target.selectionStart;
				if (e.target.value[cursorPos - 1] === '-' || e.target.value[cursorPos] === '-') {
					e.preventDefault();
					return false;
				}
			}
		}
	});

	document.addEventListener('focusout', function (e) {
		if (e.target && (e.target.id === 'mb_tel' || e.target.id === 'mb_bank_acc')) {
			if (!numhyphenRule.test(e.target.value)) {
				// 입력값이 유효하지 않은 경우, 하이픈을 제거하고 숫자만 남깁니다.
				e.target.value = e.target.value.replace(/[^0-9]/g, '');
			}
		}
	});
	

	document.addEventListener('click', function (e) {
		if (e.target && e.target.classList.contains('tooltip_icon')) {
			e.target.nextElementSibling.style.display = 'inline-block';
			e.target.nextElementSibling.style.opacity = 1;
		}
	});

	document.addEventListener('mouseout', function (e) {
		if (e.target && e.target.classList.contains('tooltip_icon')) {
			e.target.nextElementSibling.style.display = 'none';
			e.target.nextElementSibling.style.opacity = 0;
		}
	});

	// 엔터키 전송 추가
	document.addEventListener('keyup', function(e) {
		if (e.target.id === 'reg_mb_id') {
			if (e.key === 'Enter') { // 엔터키
				document.getElementById('id_check').click();
			}
		}
	});
	// 엔터키 전송 추가
	document.addEventListener('keyup', function(e) {
		if (e.target.id === 'mb_email') {
			if (e.key === 'Enter') { // 엔터키
				document.getElementById('reg_mb_email_check').click();
			}
		}
	});
	// 엔터키 전송 추가
	document.addEventListener('keyup', function(e) {
		if (e.target.id === 'phone3') {
			if (e.key === 'Enter') { // 엔터키
				document.getElementById('req_checknum_btn').click();
			}
		}
	});
}

const id_check = async (mb_id) => {
	if (!mb_id || mb_id.trim() === '') {
		return "아이디를 입력해 주세요."
	}

	var idRule = /^[a-z0-9]{6,20}$/i;
	if (!idRule.test(mb_id)) {
		return "아이디는 6~20자리 영문+숫자만 가능합니다."
	}

	const params = new URLSearchParams();
	params.append('mb_id', mb_id);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/id_check`, { params });
console.debug()
		return (response.data.result.isDuplicated)?'exist':'able';

	} catch (error) {
		console.error(error?.response?.data);
	}
};

const email_check = async (mb_email) => {
	if (!mb_email || mb_email.trim() === '') {
		return "이메일을 입력해 주세요."
	}

	//var emailRule = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
	if (!emailRule.test(mb_email)) {
		return "이메일 형식이 아닙니다."
	}

	const params = new URLSearchParams();
	params.append('mb_email', mb_email);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/email_check`, { params });

		return (response.data.result.isDuplicated)?'exist':'able';

	} catch (error) {
		console.error(error?.response?.data);
	}
};

const phone_check = async (mb_id, phone1, phone2, phone3) => {
	if (!phone2Rule.test(phone2)) {
		return "휴대전화번호 가운데 자리(숫자3~4자리) 양식에 맞지 않습니다";
	}

	if (!phone3Rule.test(phone3)) {
		return "휴대전화번호 끝자리(숫자4자리) 양식에 맞지 않습니다";
	}
	var sended_hp = `${phone1}-${phone2}-${phone3}`;

	const params = new URLSearchParams();
	params.append('mb_id', mb_id);
	params.append('sended_hp', sended_hp);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/phone_check`, { params });

		return (response.data.result.isDuplicated)?'exist':'able';

	} catch (error) {
		console.error(error?.response?.data);
	}
};

const validateBusinessNumber = (bizNum) => {
	// 하이픈(-)이 포함된 경우 제거
	bizNum = bizNum.replace(/-/g, '');

	if (!/^\d{10}$/.test(bizNum)) {
	return false;  // 형식이 맞지 않으면 false 반환
	}

	const weights = [1, 3, 7, 1, 3, 7, 1, 3, 5];
	let sum = 0;

	// 앞의 9자리의 가중치를 적용하여 합계를 구함
	for (let i = 0; i < 9; i++) {
	sum += Number(bizNum[i]) * weights[i];
	}

	// 마지막 자리는 5를 곱한 값의 일의 자리 숫자만 더함
	sum += Math.floor((Number(bizNum[8]) * 5) / 10);

	// 검증 숫자는 10에서 합계를 10으로 나눈 나머지를 뺀 값
	const checkSum = (10 - (sum % 10)) % 10;

	// 마지막 자리가 계산된 검증 숫자와 일치하는지 확인
	return checkSum === Number(bizNum[9]);
}

export { DOMLoaded, numhyphenRule, idRule, pwdRule, emailRule, phone2Rule, phone3Rule, busiRule, id_check, email_check, phone_check, validateBusinessNumber};